import { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "./components/Navbar";
import ListPage from "./components/ListPage";
import LoginPage from "./components/LoginPage";
import CreateForm from "./components/CreateForm";
import { FetchDataProvider } from "./context/FetchDataContext";
import Helper from "./utils/helper";
import { ENDPOINTS } from "./constants/api";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCreateFormVisible, setIsCreateFormVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      setIsAuthenticated(true);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchRelationshipManagers = async () => {
    try {
      const authToken = Helper.getTokenFromLocalStorage();
      const authorizationHeader = authToken ? `${authToken}` : "";
      const dealerCode = localStorage.getItem("dealer_code");

      const rmResult = await axios.get(ENDPOINTS.GET_RELATIONSHIP_MANAGERS, {
        headers: {
          Authorization: authorizationHeader,
        },
        params: {
          dealer_code: dealerCode,
        },
      });

      localStorage.setItem(
        "relationshipManagers",
        JSON.stringify(rmResult.data)
      );
    } catch (error) {
      console.error("Failed to fetch relationship managers:", error);
    }
  };

  const handleLoginSuccess = async () => {
    setIsAuthenticated(true);
    await fetchRelationshipManagers();
    setIsCreateFormVisible(true);
  };

  if (loading) return null;
  return (
    <FetchDataProvider>
      {!isAuthenticated ? (
        <LoginPage onLoginSuccess={handleLoginSuccess} />
      ) : (
        <>
          <Navbar onAddCustomer={() => setIsCreateFormVisible(true)} />
          <ListPage />
          <CreateForm
            isVisible={isCreateFormVisible}
            onClose={() => setIsCreateFormVisible(false)}
          />
        </>
      )}
    </FetchDataProvider>
  );
}

export default App;
